import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export type StepData = Record<string, any>;

interface MultiStepFormState {
  currentStep: number;
  stepData: Record<number, StepData>;
}

const initialState: MultiStepFormState = {
  currentStep: 0,
  stepData: {},
};

const multiStepFormSlice = createSlice({
  name: 'multiStepForm',
  initialState,
  reducers: {
    nextStep(state) {
      state.currentStep += 1;
    },
    prevStep(state) {
      state.currentStep = Math.max(state.currentStep - 1, 0);
    },
    goToStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setStepData(state, action: PayloadAction<{step: number; data: StepData}>) {
      state.stepData[action.payload.step] = action.payload.data;
    },
    resetForm() {
      return initialState;
    },
  },
});

export const {nextStep, prevStep, goToStep, setStepData, resetForm} =
  multiStepFormSlice.actions;

export default multiStepFormSlice.reducer;
